import CONSTANTS from '@/common/constants';
import { formatDate } from "@/common/date";

import { finance, unfinance } from '@/utils/finance';

import {
	PAYMENTS,
	BENEFITS,
	ADVANTAGES,
	GIFTS,
	GIFTS_LIST
} from './car-advantages';

import present_i from "../images/icons/ep_present.svg";
import gsm_i from "../images/icons/ep_gsm.svg";
import search_i from "../images/icons/ep_search.svg";
import service_i from "../images/icons/ep_service.svg";
import shield_i from "../images/icons/ep_shield.svg";

const count = {
	preface: 13,
	cityray: 10,
	atlas_pro: 29,
	okavango: 22,
	tugella: null,
	coolray: null,
	atlas_new: 23,
	atlas: 5,
	monjaro: 26,
	emgrand: 25,
	monjaro_hybrid: 30,
	monjaro_flagship_se: null
};

const adv_num = {
	atlas_pro: 6,
	okavango: 6,
	tugella: 4,
	coolray: null,
	atlas_new: 3,
	atlas: 2,
	monjaro: null,
	monjaro_flagship_se: null,
	emgrand: 3,
	monjaro_hybrid: 3
};

const prices = {
	// 'ex5_em-i': "3 319 990",
	cityray: '2 499 990',
}

const advantages = {
	atlas_pro: "900 000",
	okavango: "1 200 000",
	tugella: "680 000",
	// coolray: "400 000",
	atlas_new: "985 000",
	atlas: "390 000",
	monjaro: "1 420 000",
	monjaro_flagship_se: "1 420 000",
	preface: "850 000",
	cityray: "1 200 000",
	emgrand: "750 000",
	monjaro_hybrid: "1 000 000",
	ex5: '400 000',
	'ex5_em-i': "620 000",
	nordcross_001: "500 000",
};

const tradein = {
	atlas_pro: "270 000",
	okavango: "270 000",
	tugella: "250 000",
	coolray: "235 000",
	atlas_new: "235 000",
	atlas: "220 000",
	monjaro: null,
	monjaro_flagship_se: null,
	preface: null,
	cityray: null,
	emgrand: "235 000",
	monjaro_hybrid: "235 000"
};

const credit_discount = {
	atlas_pro: "220 000",
	okavango: "220 000",
	tugella: "200 000",
	coolray: "185 000",
	atlas_new: "185 000",
	atlas: "170 000",
	monjaro: null,
	monjaro_flagship_se: null,
	preface: null,
	cityray: null,
	emgrand: "185 000",
	monjaro_hybrid: "185 000"
};

const credit = {
	atlas_pro: "0,01",
	okavango: "0,01",
	tugella: "0,01",
	coolray: "0,01",
	atlas_new: "0,01",
	atlas: "0,01",
	monjaro: "0,01",
	monjaro_flagship_se: "0,01",
	preface: "0,01",
	cityray: "0,01",
	emgrand: "0,01",
	monjaro_hybrid: "0,01",
	nordcross_001: "0,01",
};

const features = {
	atlas_pro: true,
	okavango: true,
	tugella: true,
	coolray: true,
	atlas_new: true,
	atlas: true,
	monjaro: true,
	monjaro_flagship_se: true,
	preface: true,
	cityray: true,
	emgrand: true,
	monjaro_hybrid: true,
	ex5: true,
	'ex5_em-i': true,
	nordcross_001: true,
};

const gift = {
	atlas_pro: true,
	tugella: true,
	coolray: true,
	atlas_new: true,
	atlas: true,
	monjaro: true,
	monjaro_flagship_se: true,
	preface: true,
	cityray: true,
	emgrand: true,
	monjaro_hybrid: true,
	ex5: true,
	'ex5_em-i': true,
	nordcross_001: true,
};

const fresh = ['ex5', 'coolray'];

const LABEL = `Снижаем цены до ${formatDate(CONSTANTS.period.end, 'shortNumber')}`;

const CARS = [
	{
		key: "ex5_em-i",
		name: "EX5 Гибрид",
		images: 5,
		// action: `СПЕЦПРЕДЛОЖЕНИЕ до ${date}`,
		freshLabel: 'В НАЛИЧИИ',
		hybrid: true,
		colors: [
			{
				color: "#516483",
				image: "blue",
			},
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#233d2d",
				image: "green",
			},
			{
				color: "#c0c0c0",
				image: "silver",
			},
			{
				color: "#000",
				image: "black",
			},
			{
				color: "#fff",
				image: "white",
			},
		],
		activeColor: "blue",
		gallery: 14,
	},
	{
		key: "monjaro_flagship_se",
		name: "MONJARO",
		images: 1,
		freshLabel: 'В НАЛИЧИИ',
		fresh: true,
		colors: [
			{
				color: "#5e8068",
				image: "green",
			},
			{
				color: "#e1e1e1",
				image: "white",
			},
			{
				color: "#ababab",
				image: "silver",
			},
			{
				color: "#616161",
				image: "grey",
			},
			{
				color: "#000000",
				image: "black",
			},
		],
		activeColor: "green",
		gallery: 5,
	},
	{
		key: "coolray",
		name: "COOLRAY",
		images: 1,
		freshLabel: 'В НАЛИЧИИ',
		fresh: true,
		colors: [
			{
				color: "#a795c4",
				image: "violet",
			},
			{
				color: "#eeeeee",
				image: "white",
			},
			{
				color: "#595959",
				image: "grey",
			},
		],
		activeColor: "violet",
		gallery: 5,
	},
	{
		key: "cityray",
		name: "CITYRAY",
		images: 4,
		gallery: 5,
		colors: [
			{
				color: "#829ac7",
				image: "blue",
			},
			{
				color: "#ffffff",
				image: "white",
			},
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#d6d6d6",
				image: "light-grey",
			},
		],
		activeColor: "blue",
	},
	{
		key: "okavango",
		name: "OKAVANGO",
		images: 4,
		colors: [
			{
				color: "#0069b4",
				image: "blue",
			},
			{
				color: "#000",
				image: "black",
			},
			{
				color: "#888",
				image: "grey",
			},
			{
				color: "#fff",
				image: "white",
			},
		],
		activeColor: "blue",
		gallery: 13,
	},
	/* {
		key: "monjaro",
		name: "MONJARO",
		images: 6,
		colors: [
			{
				color: "#2D7289",
				image: "emerald",
			},
			{
				color: "#000000",
				image: "black",
			},
			{
				color: "#5e6775",
				image: "dark-grey",
			},
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#d6d6d6",
				image: "light-grey",
			},
			{
				color: "#FFFFFF",
				image: "white",
			},
		],
		activeColor: "white",
		gallery: 10,
	}, */
	/* {
		key: "ex5",
		name: "EX5",
		images: 5,
		freshLabel: 'В НАЛИЧИИ',
		colors: [
			{
				color: "#5e6775",
				image: "dark-grey",
			},
			{
				color: "#0069b4",
				image: "blue",
			},
			{
				color: "#888",
				image: "grey",
			},
			{
				color: "#000",
				image: "black",
			},
			{
				color: "#fff",
				image: "white",
			},
		],
		activeColor: "dark-grey",
		gallery: 3,
	}, */
	{
		key: "nordcross_001",
		name: "NORDCROSS 001",
		images: 4,
		freshLabel: 'В НАЛИЧИИ',
		colors: [
			{
				color: "#000000",
				image: "black",
			},
			{
				color: "#17278c",
				image: "blue",
			},
			{
				color: "#ffffff",
				image: "white",
			},
			{
				color: "#646464",
				image: "grey",
			},
		],
		activeColor: "black",
		gallery: 5,
	},
	/* {
		key: "atlas_new",
		name: "ATLAS",
		images: 5,
		colors: [
			{
				color: "#4c5698",
				image: "blue",
			},
			{
				color: "#1a1b1d",
				image: "black",
			},
			{
				color: "#828793",
				image: "silver",
			},
			{
				color: "#1A3C24",
				image: "green",
			},
			{
				color: "#f1f3f4",
				image: "white",
			},
		],
		activeColor: "blue",
		gallery: 14,
	},
	{
		key: "preface",
		name: "PREFACE",
		images: 6,
		colors: [
			{
				color: "#808080",
				image: "grey",
			},
			{
				color: "#ffffff",
				image: "white",
			},
			{
				color: "#9083b9",
				image: "purple",
			},
			{
				color: "#000000",
				image: "black",
			},
			{
				color: "#829ac7",
				image: "blue",
			},
			{
				color: "#1A3C24",
				image: "green",
			},
		],
		activeColor: "grey",
		gallery: 7,
	}, */

	// {
	//   key: "monjaro_hybrid",
	//   name: "MONJARO ГИБРИД",
	//   images: 1,
	// },
	// {
	//   key: "atlas_pro",
	//   name: "Atlas Pro",
	//   images: 4,
	// },
	// {
	//   key: "tugella",
	//   name: "Tugella",
	//   images: 4,
	// },
	// {
	//   key: "atlas",
	//   name: "Atlas",
	// },
].map((car) => ({
	...car,
	payment: PAYMENTS[car.key],
	benefit: BENEFITS[car.key],
	advantages: ADVANTAGES,
	gifts: GIFTS,
	gifts_list: GIFTS_LIST,
	label: LABEL
}));


export default CARS;


export const MAX_BENEFIT = finance(CARS.reduce((acc, { benefit }) => {
	if(benefit) {
		return acc < unfinance(benefit) ? unfinance(benefit) : acc;
	}

	return acc;
}, 0));

export const MIN_PAYMENTS = finance(CARS.reduce((acc, { payment }) => {
	if(payment) {
		return acc > unfinance(payment) ? unfinance(payment) : acc
	}

	return acc;
}, Infinity));
